import { Link } from 'react-router-dom';
import type { NewsItem } from '@/mocks/news';

interface NewsCardProps {
  item: NewsItem;
  layout?: 'grid' | 'list';
}

export default function NewsCard({ item, layout = 'grid' }: NewsCardProps) {
  if (layout === 'list') {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex gap-4 md:gap-5 rounded-lg p-3 md:p-4 bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
      >
        <div className="w-28 h-20 md:w-44 md:h-28 rounded-md overflow-hidden shrink-0 bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title} 资讯配图`}
            title={`${item.title} 影视资讯`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex-1 min-w-0 flex flex-col">
          <div className="flex items-center gap-2 text-xs text-foreground-500 mb-1.5">
            <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-900 font-medium">{item.tag}</span>
            <span>{item.date}</span>
          </div>
          <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
            {item.title}
          </h3>
          <p className="hidden sm:block text-sm text-foreground-600 mt-1.5 line-clamp-2 leading-relaxed">
            {item.summary}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 资讯配图`}
          title={`${item.title} 影视资讯`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-white">
          {item.tag}
        </span>
      </div>
      <div className="p-4 flex-1 flex flex-col">
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed flex-1">{item.summary}</p>
        <div className="flex items-center gap-1.5 text-xs text-foreground-500 mt-3">
          <i className="ri-calendar-line"></i>
          <span>{item.date}</span>
        </div>
      </div>
    </Link>
  );
}